// extracted by mini-css-extract-plugin
module.exports = {"button":"scrolltotop_button__3WTRe","chev_icon":"scrolltotop_chev_icon__3BJyS","thumbnail":"scrolltotop_thumbnail__S788-","scroll_icon":"scrolltotop_scroll_icon__3xxid"};